import { hasAuthToken } from '../../auth/services/auth.utils';
import { RedirectFunction, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { StorageContextService } from '../../context/storage-context/storage-context.service';

export const shortInviteRedirector: RedirectFunction = route => {
  const storage = inject(StorageContextService);
  const id = route.params['id'];
  const url = `/app/competitions?inviteCompetitionId=${id}`;
  if (hasAuthToken()) {
    return url;
  } else {
    storage.setItem('back-url', url);
    return '/auth/sign-in';
  }
};

export const COMPETITIONS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/competitions-list-page/competitions-list-page.component').then(
        m => m.CompetitionsListPageComponent
      ),
  },
  {
    path: 'history',
    loadComponent: () =>
      import('./components/competitions-history-page/competitions-history-page.component').then(
        m => m.CompetitionsHistoryPageComponent
      ),
  },
  {
    path: 'history/:id',
    loadComponent: () =>
      import('./components/competition-page/competition-page.component').then(
        m => m.CompetitionPageComponent
      ),
  },
];
